/* app/ui/map/map.load */

define(
	'app/ui/map/map.load',[
		'jquery',
		'app/ui/map/map.control',
		'app/ui/map/map.operator',
		'app/ui/arohaItinerary/itinerary',
		'app/ui/map/map.interactive',
		'pubsub'
	],
	function($, MapControl, MapOperator, MapItinerary, MapInteractive) {

		var Module;

		// key provided by client https://terabyte.atlassian.net/browse/DGLT-451
		var apiKey = 'AIzaSyBMAKNtL2zTdjFQXgfvTr3hnlg8IdmweXc';
		var apiLoaded = false;
		var google;
		var $maps;
		var $controlMaps;
		var $operatorMaps;
		var $itineraryMaps;
		var $interactiveMaps;

		return {
			init: function($elms) {
				Module = this;
				$maps = $elms;
				$controlMaps = $maps.filter('[data-map-type="control"]');
				$operatorMaps = $maps.filter('[data-map-type="operator"]');
				$itineraryMaps = $maps.filter('[data-map-type="itinerary"]');
				$interactiveMaps = $maps.filter('[data-map-type="interactive"]');

				$.subscribe('/map/loadApi', Module.loadApi);

				// If only interactive map is on page initialise the module for this
				// The MapInteractive module will only load the API code if the map is toggled to display
				// Otherwise load API and init MapControl module
				if ($maps.length) {
					if ($maps.length === 1 && $interactiveMaps.length === 1) {
						MapInteractive.init($interactiveMaps.eq(0), Module);
					} else {

						$(window).on('scroll', Module.lazyloadApi);

						if ($controlMaps.length) {
							MapControl.init($controlMaps);
						}
						if ($interactiveMaps.length) {
							MapInteractive.init($interactiveMaps.eq(0), Module);
						}
						if ($operatorMaps.length) {
							MapOperator.init($operatorMaps);
							MapInteractive.init($operatorMaps.eq(0), Module);
						}
						if ($itineraryMaps.length) {
							MapItinerary.init($itineraryMaps);
							MapInteractive.init($itineraryMaps.eq(0), Module);
						}
					}
				}
			},

			lazyloadApi: function () {
				if (Module.isMapVisible() && !apiLoaded) {
					$(window).off('scroll', Module.lazyloadApi);
					Module.loadApi();
				}
			},

			isMapVisible: function () {
				var $visibleMaps = $maps.filter(function () {
					var $map = $(this);
					var mapOffset = $map.offset();

					var mapTopAboveScreenBottom = mapOffset.top < ($(window).scrollTop() + $(window).height());
					var mapBottomBelowScreenTop = (mapOffset.top + $map.outerHeight()) > $(window).scrollTop();

					return mapTopAboveScreenBottom && mapBottomBelowScreenTop;
				});

				return $visibleMaps.length !== 0;
			},

			// Load Google Maps API version 3
			loadApi: function() {
				$.getScript('https://www.google.com/jsapi', function() {
					window.google.load('maps', '3', {
						other_params: '&key=' + apiKey,
						callback: Module.mapApiLoaded
					});
				});
			},

			// Callback function once API is loaded
			mapApiLoaded: function() {
				apiLoaded = true;
				google = window.google;

				$.publish('/map/apiLoaded');
			},

			// Utility function to return API status and google object
			getMapApiStatus: function () {
				return {
					loaded: apiLoaded,
					google: google
				};
			}
		};
	}
);
